<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates4">
<p class="centerImage"><img alt="images" id="plate4" src="images/plate4.jpg"/></p>
<p class="caption">RAF Sergeant-Pilot. I’ve made it.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates4.vue?2491086a